import { useFetchEntities } from "@/reactQueryHooks";
import { memo } from "react";
import styled, { keyframes, css } from "styled-components";
import { Chip } from "@mui/material";
import Avatar from "@mui/material/Avatar";
//-----------------------------------------------------------------

// Add pulsing animation keyframes
const pulseAnimation = keyframes`
  0% {
    border-color: #E03D3D;
  }
  50% {
    border-color: rgba(224, 61, 61, 0.3);
  }
  100% {
    border-color: #E03D3D;
  }
`;

const AssignmentRow = styled.div<{
  isCancelled: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  border: ${({ isCancelled }) => (isCancelled ? "2px solid #E03D3D" : "none")};
  border-radius: 8px;
  padding: ${({ isCancelled }) => (isCancelled ? "8px" : "0")};
  ${({ isCancelled }) =>
    isCancelled &&
    css`
      animation: ${pulseAnimation} 1s ease-in-out infinite;
    `}
`;

const NameContainer = styled.div`
  font-weight: bold;
  display: flex;
  gap: 4px;
  align-items: center;
`;

//------------------------------------------------------------------------

interface ExternalAssignmentItemProps {
  isCancelled: boolean;
  item: {
    role_id: string;
    user_id: string;
  };
  tourGroupId: string;
}

const ExternalAssignmentItem = ({
  isCancelled,
  item,
  tourGroupId,
}: ExternalAssignmentItemProps) => {
  const { data: entities } = useFetchEntities() as any;

  const role = entities?.data?.roles.find((r: any) => r._id === item.role_id);
  const user = entities?.data?.staff.find((u: any) => u._id === item.user_id);

  return (
    <AssignmentRow isCancelled={isCancelled}>
      <NameContainer>
        <Avatar sx={{ width: 25, height: 25 }}>
          <span
            style={{
              fontSize: "12px",
            }}
          >
            {user?.name
              ? user.name.charAt(0).toUpperCase()
              : "N/A".charAt(0).toUpperCase()}
          </span>
        </Avatar>
        <span>{user?.name || "N/A"}</span>
      </NameContainer>
      {role ? <Chip label={role.title} size="small" /> : <span>N/A</span>}
    </AssignmentRow>
  );
};

export default memo(ExternalAssignmentItem);
